import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteFotoKategorieCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteFotoKategorieCommandService],
  exports: []
})
export class DeleteFotoKategorieCommandServiceModule { }
